import { createAction } from "@reduxjs/toolkit";
import api from "../../services/api";
import { toastAlert } from "../../components/Toastify/index";

export const sendTask = createAction("SEND_TASK");
export const editComment = createAction("EDIT_COMMENT");
export const editSubtask = createAction("EDIT_SUBTASK");
export const editSubtasks = createAction("EDIT_CHANGES");
export const editChangesSave = createAction("EDIT_CHANGES_SAVE");
export const editTaskAccountable = createAction("EDIT_TASK_ACCOUNTABLE");
export const newFlowPost = createAction("NEW_FLOW_POST");
export const assignAllTasks = createAction("ASSIGN_ALL_TASKS");
export const newSubtask = createAction("NEW_SUBTASK");
export const deleteSubtask = createAction("DELETE_SUBTASK");
export const sortActivedFlow = createAction("SORT_ACTIVED_FLOW");
export const removeActivedFlow = createAction("REMOVE_ACTIVED_FLOW");
export const newPost = createAction("NEW_POST");
export const newPostSubtask = createAction("NEW_POST_SUBTASK");
export const clearActivedFlows = createAction("CLEAR_ACTIVED_FLOWS");
export const newFlowTitle = createAction("NEW_FLOW_TITLE");
export const newTaskTitle = createAction("NEW_TASK_TITLE");
export const searchActived = createAction("SEARCH_ACTIVED");
export const fetchSingleActivedFlow = createAction("FETCH_SINGLE_ACTIVED_FLOW");

//Novos
export const addActivedFlow = createAction("ADD_ACTIVED_FLOW");
export const clearActivedPane = createAction("CLEAR_ACTIVED_PANE");
export const undoActivedFlow = createAction("UNDO_TASK");
export const confirmTask = createAction("CONFIRM_TASK");
export const renameActivedFlow = createAction("RENAME_ACTIVED_FLOW");

//Subtasks
export const addSubtask = createAction("ADD_SUBTASK");
export const removeSubtask = createAction("REMOVE_SUBTASK");
export const updateSubtask = createAction("UPDATE_SUBTASK");

//Description
export const updateDescription = createAction("UPDATE_DESCRIPTION");

//Accountable
export const updateAccountable = createAction("UPDATE_ACCOUNTABLE_FLOW");
export const removeAccountable = createAction("REMOVE_ACCOUNTABLE_FLOW");

//Accountalbe Task
export const updateAccountableTask = createAction("UPDATE_ACCOUNTABLE_TASK");
export const removeAccountableTask = createAction("REMOVE_ACCOUNTABLE_TASK");
export const updateMultipleACC = createAction("UPDATE_ACCOUNTABLE_MULTIPLE");

//TaskLabel
export const updateTaskLabel = createAction("UPDATE_TASK_LABEL");

//CustomNotes
export const addCustomNote = createAction("ADD_CUSTOM_NOTE");
export const updateCustomNote = createAction("UPDATE_CUSTOM_NOTE");
export const removeCustomNote = createAction("REMOVE_CUSTOM_NOTE");

//Task Duration Update
export const updateTaskDuration = createAction("UPDATE_TASK_DURATION");
export const updateTaskDeadline = createAction("UPDATE_TASK_DEADLINE");

//FlowStatus control
export const updateFlowStatus = createAction("UPDATE_FLOW_STATUS");

//Overlay
export const activateOverlayForAdd = createAction(
  "ACTIVATE_OVERLAY_FOR_ADD",
  (flowId) => ({
    payload: { flowId },
  })
);
export const activateOverlayForMove = createAction(
  "ACTIVATE_OVERLAY_FOR_MOVE",
  (noteId, flowId, noteStyle) => ({
    payload: { noteId, flowId, noteStyle },
  })
);
export const deactivateOverlay = createAction("DEACTIVATE_OVERLAY");



//Adicionar Fluxo Ativo
export const handleAddActivedFlow = ({
  flowId,
  title,
  client,
  tenantId,
  description,
}) => {
  return (dispatch) =>
    api
      .post("/activedflows/new", {
        flowId,
        title,
        tenantId,
        client,
        description,
      })
      .then((res) => dispatch(addActivedFlowSucess(res.data)))
      .catch((err) => Promise.reject(err));
};
const addActivedFlowSucess = (payload) => addActivedFlow(payload);

export const handleRemoveActivedFlow = ({ flowId }) => {
  return (dispatch) =>
    api
      .put("/activedflows/delete/", {
        flowId,
      })
      .then((res) => dispatch(removeActivedFlowSuccess(res.data)))
      .catch((err) => Promise.reject(err));
};

const removeActivedFlowSuccess = (payload) => removeActivedFlow(payload);

//Retroceder estado de fluxo ativo
export const handleUndoActived = ({ flowId }) => {
  return (dispatch) =>
    api
      .put("/activedflows/undo", { flowId })
      .then((res) => dispatch(undoActivedSucess(res.data)))
      .catch((err) => dispatch(undoActivedFailure(err.message)));
};

const undoActivedSucess = (payload) => undoActivedFlow(payload);

const undoActivedFailure = (error) => {
  throw new Error(error);
};

//1 Tarefa -> 1 aresta
//1 Condicional -> n arestas

//Confirmar conclusão de tarefa/condicional
export const handleConfirmTask = ({ flowId, taskId, edgeId }) => {
  return (dispatch) =>
    api
      .put("/activedflows/node/confirm", {
        flowId,
        taskId,
        edgeId,
      })
      .then((res) => dispatch(confirmTaskSucess(res.data)))
      .catch((err) => dispatch(confirmTaskFailure(err.message)));
};

const confirmTaskSucess = (payload) => confirmTask(payload);

const confirmTaskFailure = (error) => {
  throw new Error(error);
};

//Subtasks
//New
export const handleAddSubtask = ({ taskId }) => {
  return (dispatch) =>
    api
      .post("/activedflows/task/subtask/new", { taskId })
      .then((res) => dispatch(addSubtaskSucess(res.data)))
      .catch((err) => {
        throw new Error(err.message);
      });
};
const addSubtaskSucess = (payload) => updateSubtask(payload);

//Remove
export const handleRemoveSubtask = ({ taskId, id }) => {
  return (dispatch) =>
    api
      .delete(`/activedflows/task/subtask/delete/${taskId}/${id}`)
      .then((res) => dispatch(removeSubtaskSucess(res.data)))
      .catch((err) => {
        throw new Error(err.message);
      });
};
const removeSubtaskSucess = (payload) => updateSubtask(payload);
//Update
export const handleUpdateSubtask = ({ taskId, id, title, checked }) => {
  return (dispatch) =>
    api
      .put("/activedflows/task/subtask/update", { taskId, id, title, checked })
      .then((res) => dispatch(updateSubtaskSucess(res.data)))
      .catch((err) => {
        throw new Error(err.message);
      });
};
const updateSubtaskSucess = (payload) => updateSubtask(payload);

//Task Description
export const handleUpdateDescription = ({ taskId, description }) => {
  return (dispatch) =>
    api
      .put("/activedflows/task/description/", { taskId, description })
      .then((res) => dispatch(updateDescriptionSucess(res.data)))
      .catch((err) => {
        throw new Error(err.message);
      });
};
const updateDescriptionSucess = (payload) => updateDescription(payload);

//Responsável do fluxo
export const handleUpdateAccountable = ({ id, userId }) => {
  return (dispatch) =>
    api
      .put("/activedflows/accountable/", { id, userId })
      .then((res) => dispatch(updateAccSucess(res.data)))
      .catch((err) => Promise.reject(err));
};

export const handleRemoveAccountable = ({ id }) => {
  return (dispatch) =>
    api
      .delete(`/activedflows/accountable/${id}`)
      .then((res) => dispatch(updateAccSucess(res.data)))
      .catch((err) => Promise.reject(err));
};
const updateAccSucess = (payload) => updateAccountable(payload);

//Para a parte de Task de workflow
export const handleUpdateAccountableTask = ({ id, userId }) => {
  return (dispatch) =>
    api
      .put("/activedtasks/accountable/", { id, userId })
      .then((res) => dispatch(updateAccSucessTask(res.data)))
      .catch((err) => Promise.reject(err));
};

export const handleUpdateMultipleACC = ({ tasksList, userId }) => {
  return (dispatch) =>
    api
      .put("/activedtasks/accountable/multiple", { tasksList, userId })
      .then((res) => dispatch(updateAccMultipleSucessTask(res.data)))
      .catch((err) => Promise.reject(err));
};

const updateAccMultipleSucessTask = (payload) => updateMultipleACC(payload);

export const handleRemoveAccountableTask = ({ id }) => {
  return (dispatch) =>
    api
      .delete(`/activedtasks/accountable/${id}`)
      .then((res) => dispatch(updateAccSucessTask(res.data)))
      .catch((err) => Promise.reject(err));
};
const updateAccSucessTask = (payload) => updateAccountableTask(payload);

//Rótulo de tarefa
export const handleUpdateTaskLabel = ({ label, taskId }) => {
  return (dispatch) =>
    api
      .put("/activedtasks/label/", { label, taskId })
      .then((res) => dispatch(updateTaskLabelSucess(res.data)))
      .catch((err) => Promise.reject(err));
};

const updateTaskLabelSucess = (payload) => updateTaskLabel(payload);

//Custom Note Handlers

export const handleAddCustomNote = ({ flowId, id, position }) => {
  return (dispatch) =>
    api
      .post(`activedflows/customnote`, { flowId, id, position })
      .then((res) => {
        dispatch(addCustomNoteSuccess(res.data.activedNode));
      })
      .catch((err) => {
        toastAlert({
          msg: `Ocorreu um ERRO ao adicionar a nota: ${err}`,
          isError: true,
        });
        return Promise.reject(err);
      });
};

const addCustomNoteSuccess = (payload) => addCustomNote(payload);

export const handleRemoveCustomNote = ({ noteId }) => {
  return (dispatch) =>
    api
      .delete(`activedflows/customnote/${noteId}`)
      .then((res) => {
        dispatch(removeCustomNoteSuccess(res.data));
      })
      .catch((err) => {
        toastAlert({
          msg: `Ocorreu um ERRO ao Remover a nota: ${err}`,
          isError: true,
        });
        return Promise.reject(err);
      });
};

const removeCustomNoteSuccess = (payload) => removeCustomNote(payload);

export const handleUpdateCustomNote = ({ noteId, newData }) => {
  return (dispatch) =>
    api
      .put(`activedflows/customnote/data`, { noteId, newData })
      .then((res) => dispatch(updateCustomNoteSuccess(res.data)))
      .catch((err) => {
        toastAlert({
          msg: `Ocorreu um ERRO ao Atualizar a nota: ${err} - ${err.response.data}`,
          isError: true,
        });
        return Promise.reject(err);
      });
};

const updateCustomNoteSuccess = (payload) => updateCustomNote(payload);

export const handleUpdateCustomNoteLocation = ({ noteId, newPosition }) => {
  return (dispatch) =>
    api
      .put(`activedflows/customnote/location`, { noteId, newPosition })
      .then((res) => {
        dispatch(updateCustomNoteLocationSuccess(res.data.data));
      })
      .catch((err) => {
        toastAlert({
          msg: `Ocorreu um ERRO ao mover a nota: ${err}`,
          isError: true,
        });
        return Promise.reject(err);
      });
};

const updateCustomNoteLocationSuccess = (payload) => updateCustomNote(payload);

// Tasks Duration Update
export const handleUpdateTaskDuration = ({ taskId, duration }) => {
  return (dispatch) =>
    api
      .put("/activedflows/task/durationUpdate", { taskId, duration })
      .then((res) => dispatch(updateTaskDurationSuccess(res.data)))
      .catch((err) => {
        toastAlert({
          msg: `Error updating task duration: ${err}`,
          isError: true,
        });
        return Promise.reject(err);
      });
};

const updateTaskDurationSuccess = (payload) => updateTaskDuration(payload);

export const handleUpdateDeadline = ({ taskId, delayTime }) => {
  return (dispatch) =>
    api
      .put("/activedtasks/deadline/", { taskId, delayTime })
      .then((res) => dispatch(updateTaskDeadline(res.data)))
      .catch((err) => Promise.reject(err));
};

// Update FlowStatus

export const handleUpdateFlowStatus = ({
  flowId,
  estimatedAt,
  criticalDate,
  progress,
  activeJobs,
}) => {
  return (dispatch) =>
    api
      .put("/activedflows/flowstatus", {
        flowId,
        estimatedAt,
        criticalDate,
        progress,
        activeJobs,
      })
      .then((res) => {
        dispatch(updateFlowStatusSucessful(res.data));
      })
      .catch((err) => {
        toastAlert({
          msg: `Error updating FlowStatus: ${err}`,
          isError: true,
        });
        return Promise.reject(err);
      });
};

const updateFlowStatusSucessful = (data) =>
  updateFlowStatus({
    criticalDate: data.flowStatus.criticalDate,
    estimatedAt: data.flowStatus.estimatedAt,
    progress: data.flowStatus.progress,
    activeJobs: data.flowStatus.activeJobs,
  });


  export const handleRenameActivedFlow = ({ title, flowId }) => {
    return async(dispatch) => api
        .put("/activedflows/flow/title", {
          title,
          flowId,
        })
        .then((res) => dispatch(renameActivedFlow(res.data)))
        .catch((err) => err);
  };